module.exports = require('../_components/@alicd/next-time-picker/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/time-picker/index.js
// module id = 727
// module chunks = 0